// extracted by mini-css-extract-plugin
module.exports = {"styledAccordion":"EsUi3tar","option-selected":"sjf50ABV","badge":"FC5h7ock"};